import funding1 from "../assets/Funding1.jpeg"
import funding2 from "../assets/Funding2.png"
import funding3 from "../assets/Funding3.png"
import funding4 from "../assets/Funding4.png"

export interface FundingImage {
  id: number;
  src: string;
  alt: string;
}

export interface FundingProject {
  id: number;
  title: string;
  description: string;
  images: FundingImage[];
}

export const fundingProjects: FundingProject[] = [
  {
    id: 1,
    title: "인간-동물 사이의 오컬트적 기원을 추적하여 창작의 활로를 넓힌 책",
    description: `해당 도서는 이미 현역 작가를 통해 입증된 책입니다.
인간-동물 확장 사전을 활용한 현역 작가님의 시놉시스를 확인해보세요. 현역 작가의 시놉시스를 무료 관람하실 수 있습니다.`,
    images: [
      { id: 1, src: funding1, alt: "Funding Image 1" },
      { id: 2, src: funding2, alt: "Funding Image 2" },
      { id: 3, src: funding3, alt: "Funding Image 3" },
      { id: 4, src: funding4, alt: "Funding Image 4" },
    ],
  },
  {
    id: 2,
    title: "다음 프로젝트 준비 중입니다.",
    description: `더욱 흥미롭고 다채로운 주제로 찾아올 예정입니다.
새로운 창작의 기회를 놓치지 마세요. 곧 공개될 예정이니 많은 기대 부탁드립니다.`,
    images: [],
  },
];
